export default __webpack_public_path__ + "static/media/abay.b173d75f.png";